export default {
    methods: {
      cleanObject(obj) {
          // remove all propery which has null/undefined value
          return Object.fromEntries(
            Object.entries(obj).filter(([_, value]) => value !== null && value !== undefined && value !== '')
          );
      },
      formatStartEndDate(startDate,endDate){
        const providedStartDate = new Date(startDate);
        const providedEndDate = new Date(endDate);
        const option = {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit'
        }
        const formattedStartDate = providedStartDate.toLocaleDateString('fr-CA', option);
        const formattedEndDate = providedEndDate.toLocaleDateString('fr-CA', option);


        // Format the start and end times
        const startTime = providedStartDate.toLocaleTimeString();
        const endTime = providedEndDate.toLocaleTimeString()

        const timeOptions24 = {
          hour: '2-digit',
          minute: '2-digit',
          // second: '2-digit',
          hour12: false
        };

        return {
          start_date: formattedStartDate,
          end_date: formattedEndDate,
          start_time: startTime,
          end_time: endTime,
          start_time_24h: providedStartDate.toLocaleTimeString('en-GB', timeOptions24),
          end_time_24h: providedEndDate.toLocaleTimeString('en-GB', timeOptions24)
        };
      },
      // format human readable date
      formatHDate(dateInput,remove_utc=true) { // human readable
        let givenDate = dateInput;

        if (remove_utc && typeof dateInput === 'string') {
          if (givenDate.endsWith('Z')) {
            givenDate = givenDate.slice(0, -1);
          }
        }
        const dateObj = new Date(givenDate);


        const timeOptions = {
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          hour12: true
        };

        const dateOptions = {
          year: 'numeric',
          month: 'long',
          day: 'numeric'
        };

        return {
          date: dateObj.toLocaleDateString('en-US', dateOptions), // April 23, 2025
          time: dateObj.toLocaleTimeString('en-US', timeOptions)  // 12:05:00 AM
        };
      },

      // remove time-zone from ISO string date
      removeTimeZoneFromDateSting(isoString) {
        const [datePart, timePartWithMs] = isoString.split('T');
        const timePart = timePartWithMs.split('.')[0];
        return `${datePart}T${timePart}`;
      },

      // download csv file
      downloadCSVFile(filename, headers, rows) {
        const csvContent = [headers, ...rows]
          .map(e => e.join(','))
          .join('\n');

        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.setAttribute("href", url);
        link.setAttribute("download", filename);
        link.click();
      },
      openInNewTab(url) {
        if (!url || typeof url !== 'string') {
          console.warn('Invalid URL passed to openInNewTab');
          return;
        }

        // Ensure it has a protocol
        const fullUrl = url.startsWith('http') ? url : `https://${url}`;

        window.open(fullUrl, '_blank');
      },
      generateRandomString(length = 8) {
        const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        let result = '';
        for (let i = 0; i < length; i++) {
          result += chars.charAt(Math.floor(Math.random() * chars.length));
        }
        return result;
      },
      downloadBlogResposeToxlsx(response,filename){
        // Use response.data directly (already a Blob)
        const url = URL.createObjectURL(response.data);

        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename);

        document.body.appendChild(link);  // Append for Firefox
        link.click();
        document.body.removeChild(link);

        URL.revokeObjectURL(url);
      },
      // trim and add elips
      trimAndEllipsText(str, maxLength = 50) {
        if (!str) return "";
        str = str.trim();
        return str.length > maxLength ? str.substring(0, maxLength) + "..." : str;
      },

      // end methods
    },
};
